export class Message {
    message: string = "";
    loadUID: string = "";
    token: string = "";
    hasActions: boolean = false;
}
